import { render, staticRenderFns } from "./ServeItemField.vue?vue&type=template&id=6d1325fd"
import script from "./ServeItemField.vue?vue&type=script&lang=js"
export * from "./ServeItemField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports